import { useEffect, useMemo, useState } from "react";
import { COMMUNITY_CLUP, DEFAULT, USER } from "../api";
import { differenceInCalendarDays, format } from "date-fns";
import CommunityClupParticipate from "./community-clup/participate";

export default function AsmMake() {
	const [data, setData] = useState<any>([]);
	const [communities, setCommunities] = useState<any>([]);
	const [img, setImg]: any = useState({});

	useEffect(() => {
		DEFAULT.getServiceConfig().then((res) => {
			setImg(res);
		});
	}, []);

	useEffect(() => {
		USER.getMyOrders().then((res) => {
			setData(res.reverse());
		});
		COMMUNITY_CLUP.getMyCommunity().then((res) => {
			setCommunities(res);
		});
	}, []);

	return (
		<div className="flex justify-center">
			<div className="w-full max-w-lg">
				<div className="overflow-hidden relative">
					<div
						className="w-full h-[230px] bg-cover bg-center blur-sm scale-125"
						style={{
							backgroundImage: `url(${img?.travelRecruitmentImageUrl})`,
						}}></div>
					<div
						dangerouslySetInnerHTML={{ __html: img?.travelRecruitmentText }}
						className="absolute inset-0 w-full h-full flex flex-col gap-4 justify-center items-center"></div>
				</div>

				<div className=" text-[#202c4a] px-3 mt-5 gap-1 flex items-center">{Icon} 나의 주문 리스트</div>
				<div className="grid grid-cols-2 gap-2 px-3 mt-5">
					{data?.filter((e: any) => {
						return e.status === "PAYMENT_COMPLETE" && new Date(e.startedAt).getTime() - new Date().getTime() > 0;
					}).length > 0 &&
						data
							?.filter((e: any) => {
								return e.status === "PAYMENT_COMPLETE" && new Date(e.startedAt).getTime() - new Date().getTime() > 0;
							})
							.sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
							.slice(0, 2)
							.map((item: any) => {
								const startedAt = new Date(item.startedAt);
								const endedAt = new Date(item.endedAt);

								const diff = differenceInCalendarDays(endedAt, startedAt);
								// 박 몇일
								const rangeText = `${diff}박 ${diff + 1}일`;

								const quotation = item.PartnerQuotations.find((v: any) => v.selectedAt !== null);
								return (
									<div
										onClick={() => (window.location.href = `/community_makeCommunity?order_id=${item.id}`)}
										className="border border-[#dadada] rounded-sm shadow-md">
										<div
											className="h-[186px] w-full bg-gray-200 flex justify-center items-center text-sm text-[#999] relative bg-center bg-cover"
											style={
												{
													// 주문에 이미지가 있을 수 없음
													// backgroundImage: `url(${item?.PartnerQuotations?.[0].PartnerQuotationFiles?.[0]?.File?.url})`,
												}
											}>
											<div className="text-[10px] text-white font-medium absolute top-1 left-1 bg-[#355c7d] px-2 py-0.5 rounded-sm">
												{item.nation}/{rangeText}
											</div>
										</div>

										<div>
											<div className="text-[#777] text-xs font-bold mt-2.5 px-1.5">
												{item.numberOfRecruits}명 모집중{`${item.type !== "RECRUITMENT" ? "" : "·" + item.recruitGenderTypeText}`}
												{`${item.type !== "RECRUITMENT" ? "" : "·" + item.ageGroup}`}
											</div>
											<div className="text-xs px-1.5 my-1.5 text-[#777] font-normal">{item.tripType}</div>
											<div className="px-1.5 text-[10px] text-[#777] font-normal">
												{format(startedAt, "yyyy-MM-dd")} ~ {format(endedAt, "yyyy-MM-dd")}
											</div>
											<div className="px-2 text-right text-xs text-black font-bold mt-3">
												{item.PartnerQuotations?.[0]?.finalQutotePrice ? item.PartnerQuotations?.[0]?.finalQutotePrice + "원" : "견적 측정중"}
											</div>
										</div>
									</div>
								);
							})}
				</div>
				{data?.filter((e: any) => {
					return e.status === "PAYMENT_COMPLETE" && new Date(e.startedAt).getTime() - new Date().getTime() > 0;
				}).length === 0 && (
					<div>
						<div className="border border-[#dadada] py-10 flex flex-col items-center justify-center">
							<div className="font-bold text-black text-center">
								아직 주문한 내역이 없어요😢
								<br />✈ 지금 여행을 계획 하시겠어요?
							</div>
							<div className="text-sm text-[#424549] mt-8">[여행 주문하기]</div>
							<div className="text-[#424549] text-xs font-medium mt-1.5">
								내가 만들고 싶은 여행을 주문하면 다양한 견적을 받아볼 수 있습니다.
								<br />
								견적이 확정되면 함께 여행할 크루 모집도 가능해요!
							</div>

							<div className="text-sm text-[#424549] mt-8">[크루와 여행하기]</div>
							<div className="text-[#424549] text-xs font-medium mt-1.5">
								커뮤니티를 통해 크루들과 함께 여행 계획을 세울 수 있습니다.
								<br />
								계획이 정해졌다면 [여행 주문하기]를 통해 견적을 받아보세요.
							</div>
						</div>
						<div className="flex mt-5 gap-4">
							<div
								onClick={() => (window.location.href = "/travel_Order")}
								className="py-3 border border-[#dadada] flex-1 flex justify-center items-center text-success text-sm font-bold cursor-pointer">
								여행 주문하기
							</div>
						</div>
					</div>
				)}

				{data?.filter((e: any) => {
					return e.status === "PAYMENT_COMPLETE" && new Date(e.startedAt).getTime() - new Date().getTime() > 0;
				}).length > 0 && (
					<div className="px-3">
						<div
							onClick={() =>
								(window.location.href = `/community_makeCommunity?order_id=${
									data?.filter((e: any) => {
										return e.status === "PAYMENT_COMPLETE" && new Date(e.startedAt).getTime() - new Date().getTime() > 0;
									})?.[0].id
								}`)
							}
							className="text-sm text-success font-bold border rounded-sm border-[#dadada] flex justify-center items-center mt-5 py-3">
							크루 모집하기
						</div>
					</div>
				)}

				<div className=" text-[#202c4a] px-3 mt-5 gap-1 flex items-center">{Icon} 나의 모집 내역</div>
				<div className="px-3 text-[10px] mt-2 text-black font-normal">크루들과 함께한 지난 여행은 어떠셨나요? 우리 여행에 대한 리뷰를 남겨주세요📝💌</div>
				<div className="px-3 text-[10px] mt-1 text-[#777] font-medium">📢 현재 모집중인 상품은 [여행 참여하기] 카테고리에서 확인해주세요.</div>

				<div className="grid grid-cols-2 gap-2 px-3 mt-5">
					{communities?.slice(0, 2).map((item: any) => {
						const startedAt = new Date(item.startedAt);
						const endedAt = new Date(item.endedAt);

						const diff = differenceInCalendarDays(endedAt, startedAt);
						// 박 몇일
						const rangeText = `${diff}박 ${diff + 1}일`;
						const image = item.CommunityClupFile.find((v: any) => v.type === "PROMOTION").File.url;

						const quotation = item.PartnerQuotations?.find((v: any) => v.selectedAt !== null);
						return (
							<div onClick={() => (window.location.href = `/community/${item.id}/details`)} className="border border-[#dadada] rounded-sm shadow-md cursor-pointer">
								<div
									className="h-[186px] w-full bg-gray-200 flex justify-center items-center text-sm text-[#999] relative  bg-center bg-cover"
									style={{
										backgroundImage: `url(${image})`,
									}}>
									<div className="text-[10px] text-white font-medium absolute top-1 left-1 bg-[#355c7d] px-2 py-0.5 rounded-sm">
										{item.nation}/{rangeText}
									</div>
								</div>

								<div>
									<div className="text-[#777] text-xs font-bold mt-2.5 px-1.5">
										{item.numberOfRecruits}명 모집중{`${item.type !== "RECRUITMENT" ? "" : "·" + item.recruitGenderTypeText}`}
										{`${item.type !== "RECRUITMENT" ? "" : "·" + item.ageGroup}`}
									</div>
									<div className="text-xs px-1.5 my-1.5 text-[#777] font-normal">{item.tripType}</div>
									<div className="px-1.5 text-[10px] text-[#777] font-normal">
										{format(startedAt, "yyyy-MM-dd")} ~ {format(endedAt, "yyyy-MM-dd")}
									</div>
									<div className="px-2 text-right text-xs text-black font-bold mt-3">{quotation ? `${quotation.to}원` : "-"}</div>
								</div>
							</div>
						);
					})}
				</div>
				{communities?.length === 0 && (
					<div className="leading-7 py-32 text-center border border-[#dadada]">
						지난 모집 내역이 없어요😢
						<br />
						저희와 함께 첫 여행을 떠나보는건 어떠신가요?
					</div>
				)}
			</div>
		</div>
	);
}

const Icon = (
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12.3739 2.25001C12.6696 2.24894 12.9626 2.30635 13.236 2.41894C13.5099 2.53169 13.7587 2.69755 13.9681 2.90695C14.1775 3.11635 14.3433 3.36514 14.4561 3.63897C14.5687 3.91237 14.6261 4.20533 14.625 4.50099C14.625 4.50145 14.625 4.50191 14.625 4.50237L14.0625 4.50001H14.625V4.50099V12.375C14.625 12.6857 14.3732 12.9375 14.0625 12.9375C13.7518 12.9375 13.5 12.6857 13.5 12.375V4.50001L13.5 4.49766C13.5006 4.35005 13.472 4.20379 13.4158 4.06731C13.3596 3.93082 13.2769 3.80682 13.1726 3.70245C13.0682 3.59807 12.9442 3.5154 12.8077 3.45921C12.6712 3.40301 12.525 3.37439 12.3774 3.37501L12.375 3.37501H2.8125C2.50184 3.37501 2.25 3.12317 2.25 2.81251C2.25 2.50185 2.50184 2.25001 2.8125 2.25001H12.3739ZM12.3739 2.25001C12.3735 2.25002 12.3731 2.25002 12.3726 2.25002L12.375 2.81251V2.25001H12.3739Z"
			fill="#202C4A"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M6.75 7.3125C6.75 7.00184 7.00184 6.75 7.3125 6.75H11.8125C12.1232 6.75 12.375 7.00184 12.375 7.3125C12.375 7.62316 12.1232 7.875 11.8125 7.875H7.3125C7.00184 7.875 6.75 7.62316 6.75 7.3125Z"
			fill="#202C4A"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M6.75 9.5625C6.75 9.25184 7.00184 9 7.3125 9H11.8125C12.1232 9 12.375 9.25184 12.375 9.5625C12.375 9.87316 12.1232 10.125 11.8125 10.125H7.3125C7.00184 10.125 6.75 9.87316 6.75 9.5625Z"
			fill="#202C4A"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M2.94604 3.38387C2.76503 3.36223 2.58148 3.3849 2.41117 3.44994C2.24087 3.51497 2.08892 3.62041 1.9684 3.75719C1.84789 3.89398 1.76241 4.05799 1.71935 4.23513C1.67628 4.41227 1.6769 4.59722 1.72116 4.77407C1.76543 4.95091 1.852 5.11435 1.97344 5.25032C2.18038 5.48202 2.16031 5.83761 1.92861 6.04455C1.6969 6.25149 1.34132 6.23142 1.13437 5.99971C0.891504 5.72778 0.718354 5.40091 0.629829 5.04722C0.541304 4.69353 0.540056 4.32363 0.626193 3.96935C0.71233 3.61507 0.883271 3.28703 1.1243 3.01347C1.36533 2.73991 1.66923 2.52902 2.00984 2.39895C2.35045 2.26889 2.71757 2.22354 3.07959 2.26682C3.44161 2.3101 3.78769 2.44071 4.08804 2.6474C4.38839 2.8541 4.63401 3.13068 4.80376 3.45336C4.97351 3.77603 5.0623 4.13512 5.0625 4.49971V13.4997C5.0626 13.682 5.10699 13.8616 5.19187 14.0229C5.27675 14.1842 5.39956 14.3225 5.54973 14.4259C5.69991 14.5292 5.87295 14.5945 6.05396 14.6162C6.23497 14.6378 6.41852 14.6151 6.58883 14.5501C6.75913 14.4851 6.91108 14.3796 7.0316 14.2428C7.15211 14.1061 7.23759 13.942 7.28065 13.7649C7.32372 13.5878 7.3231 13.4028 7.27884 13.226C7.23457 13.0491 7.148 12.8857 7.02656 12.7497C6.87885 12.5843 6.84208 12.3476 6.93269 12.1452C7.02329 11.9428 7.22434 11.8125 7.44609 11.8125H15.3211C15.4812 11.8125 15.6336 11.8807 15.7404 12C16.03 12.3238 16.2197 12.7246 16.2865 13.1538C16.3534 13.5831 16.2945 14.0225 16.117 14.4191C15.9396 14.8156 15.6511 15.1523 15.2865 15.3885C14.9219 15.6246 14.4968 15.7502 14.0625 15.75C14.0624 15.75 14.0626 15.75 14.0625 15.75H6.1875C6.17502 15.75 6.16263 15.7496 6.15035 15.7488C6.07367 15.7475 5.99693 15.7424 5.92041 15.7332C5.55839 15.6899 5.21231 15.5593 4.91196 15.3526C4.61161 15.1459 4.36599 14.8693 4.19624 14.5467C4.02649 14.224 3.93769 13.8649 3.9375 13.5003V4.50032C3.9374 4.31802 3.89301 4.13847 3.80813 3.97714C3.72325 3.8158 3.60044 3.67751 3.45027 3.57416C3.30009 3.47081 3.12705 3.40551 2.94604 3.38387ZM8.13554 14.625H14.0625C14.2797 14.6251 14.4926 14.5623 14.6749 14.4442C14.8572 14.3262 15.0014 14.1578 15.0902 13.9595C15.1789 13.7613 15.2083 13.5415 15.1749 13.3269C15.1534 13.1891 15.1067 13.0572 15.0376 12.9375H8.36629C8.3676 12.9426 8.36889 12.9477 8.37017 12.9528C8.4587 13.3065 8.45994 13.6764 8.37381 14.0307C8.32294 14.2399 8.24251 14.4399 8.13554 14.625Z"
			fill="#202C4A"
		/>
	</svg>
);
